<template>
  <div class="bg">
    <div class="box">
      <div class="window">
        <div class="window-left">
          <div class="window-left-title">养老机构服务信用评价平台</div>
          <img class="window-left-img" src="../assets/login.png"/>
        </div>
        <div class="window-right">
          <div class="window-right-title login-title">欢 迎 登 录</div>
          <el-input
            @keyup.enter.native="doLogin" class="login-input" v-model="username" placeholder="请输入用户名"/>
          <el-input
            @keyup.enter.native="doLogin" class="login-input" v-model="password" placeholder="请输入密码" show-password/>
          <div class="yzm" v-if="captchaEnabled">
            <el-input
              @keyup.enter.native="doLogin" class="login-input yzm-input" v-model="code" placeholder="请输入验证码"/>
            <img id="yzmimg" :src="yzmUrl" alt="验证码" @click="getCode">
          </div>
          <el-button class="login-btn" type="primary" @click="doLogin()" :loading="loading">
            <span v-if="!loading">立即登录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div class="login-btm">
            <a href="javascript:void(0);" class="login-btm-one" @click="registerSelect(this)">立即注册</a>
            <router-link to="/forgotPassword">忘记密码？</router-link>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getCodeImg, login, autoLogin} from "../api/login";

import Cookies from "js-cookie";

export default {
  name: 'Login',
  data() {
    return {
      // 验证码开关
      captchaEnabled: true,
      // 验证码
      yzmUrl: "",
      loading: false,
      uuid: "",
      username: "",
      password: "",
      code: "",
      param: "",
      user: {},
    }
  },
  created() {
    this.getCode();
    this.param = this.$route.query.param;
    this.doAutoLogin();
  },
  mounted() {
  },
  methods: {
    // 获取验证码
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.yzmUrl = "data:image/gif;base64," + res.img;
          this.uuid = res.uuid;
        }
      });
    },
    // 登录
    doLogin() {
      if (!this.username) {
        this.$message.error("请输入用户名")
        return
      }
      if (!this.password) {
        this.$message.error("请输入密码")
        return
      }
      if (!this.code) {
        this.$message.error("请输入验证码")
        return
      }
      this.loading = true;
      // 登录
      login({
        code: this.code,
        password: this.password,
        username: this.username,
        uuid: this.uuid,
      }).then((res) => {
        // 将用户信息放入缓存
        Cookies.set("uuid", this.uuid, {expires: 30});
        Cookies.set("username", this.username, {expires: 30});
        Cookies.set("token", res.token, {expires: 30});
        Cookies.set("roles", res.roles, {expires: 30});
        Cookies.set("permissions", res.permissions, {expires: 30});
        this.$message.success("登录成功")
        this.$router.push({path: "/"}).catch(() => {
        });
      }).catch(() => {
        this.loading = false;
        if (this.captchaEnabled) {
          this.getCode();
        }
      });
    },
    // 自动登录
    doAutoLogin() {
      if (!this.param) return;
      this.loading = true;
      // 自动登录
      autoLogin({
        param: this.param
      }).then((res) => {
         // 将用户信息放入缓存
        this.user = res.user
        Cookies.set("uuid", this.uuid, {expires: 30});
        Cookies.set("username", res.user.userName, {expires: 30});
        Cookies.set("token", res.token, {expires: 30});
        Cookies.set("roles", res.roles, {expires: 30});
        Cookies.set("permissions", res.permissions, {expires: 30});
        this.$message.success("登录成功")
        this.$router.push({path: "/"}).catch(() => {
        });
      }).catch(() => {
        this.loading = false;
        if (this.captchaEnabled) {
          this.getCode();
        }
      });
    },
    registerSelect() {
      this.$confirm('请选择注册身份', '提示', {
        confirmButtonText: '企     业',
        cancelButtonText: '个    人',
        customClass: 'customConfirm',
        // confirmButtonClass: 'btnCancel',
        cancelButtonClass: 'el-button--primary',
        distinguishCancelAndClose: true,
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.$router.push({path: "/register"}).catch(() => {
            });
          } else if (action === 'cancel') {
            this.$router.push({path: "/registerPerson"}).catch(() => {
            });
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.login-title {
  margin: 20px auto 60px;
}

a {
  font-size: 16px;
  font-weight: 400;
  color: rgba(63, 140, 255, 1);
}

.login-btm {
  margin-top: 50px;
}

.login-btm-one {
  margin-right: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue